module.exports = __webpack_public_path__ + "static/media/favedeals.bdc29ac9.svg";